import { useRef, useEffect, forwardRef, useImperativeHandle } from "react";

import { v4 as uuidv4 } from "uuid";
import * as Paho from "paho-mqtt";

interface propsType {
  broadSeq: string;
  requestUrl: string;
  recieveIoTMessage: any;
  iotConnectEnd: any;
  iotLost: any;
}

const IoTClient = (props: propsType, ref: any) => {
  let clientId = useRef<string>("");
  let mqtt_client: any = useRef();

  useEffect(() => {
    return () => {
      mqtt_client.current.disconnect();
    };
  }, []);

  const subscribeTopic = () => {
    try {
      mqtt_client.current?.subscribe(`live/${props.broadSeq}/payload`, {
        onSuccess: function () {
          console.info("subscribeSucess");
        },
        onFailure: function () {
          console.error("subscribeFailed retry");
          setTimeout(() => {
            subscribeTopic();
          }, 1000);
        },
      });
      mqtt_client.current?.subscribe(`live/${props.broadSeq}/metadata`, {
        onSuccess: function () {
          // console.info("subscribeSucess : topic = live");
        },
        onFailure: function () {
          console.error("subscribeFailed");
        },
      });
    } catch (e) {
      console.error("subscribe ERROR", e);
    }
  };

  const connect = () => {
    if (props.broadSeq !== undefined && props.requestUrl !== "") {
      mqtt_client.current = initMqttClient(props.requestUrl);

      mqtt_client.current.onConnectionLost = function (err: any) {
        console.info("MQTT Connection Lost : ", err);
        props.iotLost();
      };

      mqtt_client.current.onMessageArrived = function (msg: any) {
        const topic = msg.destinationName;
        try {
          const pay_load = JSON.parse(msg.payloadString);
          props.recieveIoTMessage(topic, pay_load, clientId.current);
        } catch (e) {
          console.error("onMessageArrived error : ", e);
        }
      };

      var connectOptions: any = {
        onSuccess: function () {
          props.iotConnectEnd();
          subscribeTopic();
        },
        useSSL: true,
        timeout: 3,
        mqttVersion: 4,
        onFailure: function (errorMessage: any) {
          console.error("connectionLost", errorMessage);
          setTimeout(() => {
            props.iotLost();
          }, 1000);
        },
      };
      mqtt_client.current?.connect(connectOptions);
    }
  };
  useEffect(() => {
    connect();
  }, [props.broadSeq]);

  const initMqttClient = (requestUrl: string) => {
    clientId.current = "live-mobile-client-" + uuidv4();
    var mqtt_client = new Paho.Client(requestUrl, clientId.current);

    return mqtt_client;
  };

  const sendIoTMessageMeta = (topic: string, meta: string) => {
    const iotPayload = { topic: "live/metadata", senderId: clientId.current, message: meta };
    sendIoTMessage(topic, iotPayload);
  };

  const sendIoTMessage = (topic: string, payload: any) => {
    mqtt_client.current?.send(topic, JSON.stringify(payload), 1);
  };

  useImperativeHandle(ref, () => ({
    connect,
    sendIoTMessageMeta,
    sendIoTMessage,
  }));

  return <></>;
};

export default forwardRef(IoTClient);
